const isDevelopment = process.env.NODE_ENV === 'development';

export const ENABLED_EXTERNAL_END_POINT = false;

export const OPPORTUNITY__STAGES = isDevelopment ? {
  SALES_IN_PROGRESS: 4,
  SALES_AWAITING_SUPPLIER: 20,
  SUPPLIER_IN_PROGRES: 21,
  SUPPLIER_DONE: 22,
  SALES_QUOTE_SENT: 23,
  SALES_QUOTE_SENT_GO_AHEAD: 23853,
  SALES_REVISION_REQUEST: 21247
} : {
  SALES_IN_PROGRESS: 4,
  SALES_AWAITING_SUPPLIER: 20,
  SUPPLIER_IN_PROGRES: 21,
  SUPPLIER_DONE: 22,
  SALES_QUOTE_SENT: 23,
  SALES_QUOTE_SENT_GO_AHEAD: 465261,
  SALES_REVISION_REQUEST: 339248
};

export const OPPORTUNITY_EXPORT_TYPES = {
  QUOTE_PDF: {
    name: "quote_pdf"
  },
  AGENT_QUOTE_PDF: {
    name: "agent_quote_pdf"
  },
  SALES_FLYER_PDF: {
    name: "sales_flyer_pdf"
  },
  GUEST_DOCUMENTATION: {
    name: "guest_documentation"
  },
  WEBLINK: {
    name: "weblink"
  },
  AGENT_WEBLINK: {
    name: "agent_weblink"
  },
  LANDING_PAGE: {
    name: "landing_page"
  }
}

export const OPPORTUNITY_EXPORT_SECTIONS_IDS = {
  COVER: 1,
  LETTER: 2,
  ITINERARY: 3,
  INCLUSIONS: 4,
  TERMS_CONDITIONS: 5,
  BOOK_MY_GROUP: 6,
  CONTACT_US: 7,
  MAP: 8,
  PRICING: 9,
  AIR_CONTRACT: 11,
  DATES: 10,
  SHIP_DETAILS: 12,
}

export const TRAFALGAR_RIVER_SALES_FLYER_PDF_TEMPLATES = [
  {
    id: 1,
    name: "2 Pages Sales Flyer",
    image: "/img/flyer_templates/tt_flyer_option_2_img.png"
  },
];

export const CUSTOM_SALES_FLYER_PDF_TEMPLATES = [
  {
    id: 1,
    name: "Regular Sales Flyer",
    image: "/img/flyer_templates/tt_flyer_option_1_img.png"
  },
  {
    id: 2,
    name: "2 Pages Sales Flyer",
    image: "/img/flyer_templates/tt_flyer_option_2_img.png"
  },
  {
    id: 3,
    name: "2 Pages Sales Flyer with Highlights",
    image: "/img/flyer_templates/tt_flyer_option_3_img.png"
  }
]

export const SCHEDULED_SALES_FLYER_PDF_TEMPLATES = [
  ...CUSTOM_SALES_FLYER_PDF_TEMPLATES,
  {
    id: 4,
    name: "2 Pages Sales Flyer with Map (Schedule)",
    image: "/img/flyer_templates/tt_flyer_option_4_img.png"
  }
]

export const OPPORTUNITY__TYPES = {
  CUSTOM: 18,
  SCHEDULED: 2
}

export const OPPORTUNITY__BRANDS = isDevelopment ? {
  CONTIKI: 18926,
  TRAFALGAR: 14,
  TRAFALGAR_RIVER: 24613,
} : {
  CONTIKI: 142340,
  TRAFALGAR: 14,
  TRAFALGAR_RIVER: 494499,
}

export const BRAND = {
  TRAFALGAR_RIVER: "trafalgarriver",
};
